import styled, {keyframes} from 'styled-components';
const shine = keyframes`
  0% {
    background-position: -468px 0;
  }
  
  100% {
    background-position: 468px 0; 
  }
`;
export const Placeholder = styled.div`
  width: ${p => (p.width ? p.width : '1rem')};
  height: ${p => (p.height ? p.height : '1rem')};
  border-radius: ${p => (p.radius ? p.radius : '0.2rem')};
  margin-left: ${p => (p.marginLeft ? p.marginLeft : 0)};
  margin-right: ${p => (p.marginRight ? p.marginRight : 0)};
  margin-top: ${p => (p.marginTop ? p.marginTop : 0)};
  margin-bottom: ${p => (p.marginBottom ? p.marginBottom : 0)};
  background: ${p => (p.backgroundColor ? p.backgroundColor : '#f6f7f8')};
  background-image: ${p =>
    p.shimmerColor
      ? p.shimmerColor
      : 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)'};
  background-repeat: no-repeat;
  background-size: 800px 400px;
  display: inline-block;
  position: relative;
  animation: ${shine} 1s linear infinite;
  flex-shrink: 0;
`;
